export default "https://cdn-static.gokick.com/assets/528ec2ebd6131ff545f204827e0544e2c800444b/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";